<template>
  <ul class="zxtype">
    <li>
      <template v-if="readonly">区域</template>
      <Select v-else v-model="area">
        <Option v-for="a in areas" :value="a" :key="a">{{ a }}</Option>
      </Select>
    </li>
    <li><template v-if="readonly">类型</template>
      <Select v-else v-model="type">
        <Option v-for="a in types" :value="a" :key="a">{{ a }}</Option>
      </Select>
    </li>
    <li><template v-if="readonly">币别</template>
      <currency v-model="currency" v-else>人民币</currency>
    </li>
  </ul>
</template>
<script>
import currency from "./currency.vue";

export default {
  props: ["readonly", "zxConfig", "zxtype", "zxcurrency"],
  components: { currency },
  data() {
    return {
      areas: ['大陆', '香港'],
      types: ['装货', '卸货', '装卸货'],

      type: "", //装卸方式,
      currency: "",
      area: "" //装卸区域
    };
  },
  methods: {
    chushihua() {
      if (this.zxConfig) {
        this.area = this.zxConfig.area;
        this.currency = this.zxConfig.currency;
        this.type = this.zxConfig.type;
      }


    },

  },
  mounted() {
    this.chushihua();
  },
  watch: {
    zxConfig(v) {
     if(v==null){
     this.chushihua();
     }else{
      this.area = v.area==null?'':v.area;
     this.currency = v.currency;
      this.type = v.type;
     }
      
    },
    area(v) {
      var zxConfig = {
        type: this.type, //装卸方式,
        currency: this.currency,
        area: this.area //装卸区域
      }
      this.$emit('zxConfig', zxConfig)
    },
    currency(v) {
      var zxConfig = {
        type: this.type, //装卸方式,
        currency: this.currency,
        area: this.area //装卸区域
      }
      this.$emit('zxConfig', zxConfig)
    },
    type(v) {
      var zxConfig = {
        type: this.type, //装卸方式,
        currency: this.currency,
        area: this.area //装卸区域
      }
      this.$emit('zxConfig', zxConfig)
    }
  },
};
</script>
<style lang="">
.zxtype{
  display:flex;
  width:200px;
}
.zxtype li{
  flex:1
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/zhuangxieType.vue